import React, { useState } from 'react';

const BrandMark = ({ size = 44, className = '', alt = 'Rebel Prompts' }) => {
  const [failed, setFailed] = useState(false);
  const src = `${process.env.PUBLIC_URL || ''}/rebel-logo.png`;

  if (failed) {
    return (
      <div
        className={`brand-mark fallback ${className}`}
        style={{ width: size, height: size }}
        aria-label={alt}
      >
        <span>RP</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`brand-mark ${className}`}
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
    />
  );
};

export default BrandMark;
